// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__SPZZI","consentsList":"PatientConsents_consentsList__1OBj1","consentsListEmpty":"PatientConsents_consentsListEmpty__3lj9g"};